import React, { useEffect } from "react";

const ShareIdPhotoApp = () => {
  useEffect(() => {
    const detectDeviceAndRedirect = () => {
      const userAgent = navigator.userAgent.toLowerCase();

      const isIOS = /iphone|ipad|ipod/.test(userAgent);

      if (isIOS) {
        window.location.href =
          "https://apps.apple.com/us/app/passport-id-photo-print/id6757211469";
      } else {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.shrestha.idphotoprint";
      }
    };

    detectDeviceAndRedirect();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <p>Redirecting to app store...</p>
      </div>
    </div>
  );
};

export default ShareIdPhotoApp;
